<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/video']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'video_common_name' | translate"></nz-statistic>
    </a>
</nz-card>